import React from 'react';
// import { useHistory } from 'react-router-dom';
// import { ppiPublishedRoute } from '../routes';
import Table from '../components/Table/Table';
import { EnrichmentData, States } from '../features/PpiContainer/constants';
import usePpis from '../features/PpiContainer/hooks/usePpis';
import useViewVisited from '../features/app/hooks/useViewVisted';
import ppiColumns from '../features/PpiContainer/ui/columns';
import View from './views';
import PaperContainer from '../components/common/PaperContainer';

const PpiPublishedListView = () => {
  // const history = useHistory();
  const [isFetching, ppis] = usePpis(States.PUBLISHED);
  const { isViewVisited } = useViewVisited('PPI_PUBLISHED', isFetching);
  const isFetched = isViewVisited ? true : !isFetching;
  const Columns = ppiColumns(EnrichmentData.PUBLISHED);

  // const gotoPublishedPpi = ppi => {
  //   history.push(ppiPublishedRoute(ppi.id));
  // };

  View.PpiListPublished.visit();

  return (
    <PaperContainer showProgress={!isFetched}>
      <Table
        title="ppi.publishedListTableTitle"
        data={ppis}
        columns={[
          Columns.IFoodID,
          Columns.PresentationName,
          Columns.ActualPublishedDate,
          Columns.PublishedBy,
          Columns.Updates
        ]}
        getObjectId={object => object.id}
        defaultSorting={[{ columnName: 'presentationName', direction: 'asc' }]}
        selectable
        // onRowClick={gotoPublishedPpi}
      />
    </PaperContainer>
  );
};

export default PpiPublishedListView;
